var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white-darker-1",attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}}),_c('router-view'),_c('app-toaster')],1)}
var staticRenderFns = []

export { render, staticRenderFns }